import React from 'react';
// import { Link } from 'react-router-dom'; // (optional) remove if not used
import ContactForm from '../Components/ContactForm/ContactForm.jsx';
import WorkCard from '../Components/WorkCard/WorkCard.jsx';
import { projects } from "../data/projects.js";
import './style-sheet.css';

import profilePic from '../Components/Assets/profil-pic.png';

// Double slash fixed here:
//import customWebsite from '../Components/Assets/icon-folder/custom-website.png';
//import responsive from '../Components/Assets/icon-folder/responsive.png';
//import searchIcon from '../Components/Assets/icon-folder/search.png';
//import management from '../Components/Assets/icon-folder/management.png';
//import localIcon from '../Components/Assets/icon-folder/local.png';
//import wordpress from '../Components/Assets/icon-folder/Wordpress.png';
import gitIcon from '../Components/Assets/github-mark.png';
import lIIcon from '../Components/Assets/LI-In-Bug.png';
import { Warning } from '../Components/Warning/Warning';


export const Home = () => {
  return (

    <main className="grid">
      <div className="div-hero">
        <h1 className="h1white" id="mainHeading">
          <strong>Din Nye Website &amp; Applikation udvikler </strong>
        </h1>
        <h2 className="h2white" id="subHeading">
          Jeg specialiserer mig i at udvikle stabile og effektive løsninger til moderne hjemmesider og applikationer.<br></br>
          <br></br>Scroll ned for at få indblik i mine færdigheder, erfaringer og projekter.
        </h2>

      </div>

      <div className='div-warning'><Warning /></div>

      <div className="div-Om">
        <div className="omTitle"></div>

        <img className="profile-pic" src={profilePic} alt="Profilbillede af Lars Schou Gregersen" />
        <div>

          <div className="omText">
            <h2>Om mig</h2>
            <p>
              Mit navn er Lars Schou Gregersen, jeg er 35 år og en engageret dansk softwareudvikler med base på Sjælland.
              Jeg har specialiseret mig i <strong>softwareudvikling og avanceret programmering</strong> gennem en
              <strong>Diploma of Information Technology – Advanced Programming</strong> fra TAFE Queensland i Australien.
              Under uddannelsen har jeg arbejdet intensivt med <strong>Java, C#, JavaScript, React, Express, Python, HTML og CSS</strong>
              samt databaser <strong>MySQL og NoSQL</strong> som MariaDB og MongoDB. Dette har givet mig erfaring med at udvikle komplette løsninger,
              fra backend-logik og databaseintegration til moderne frontend-designs.
            </p>
            <p>
              Jeg har udviklet forskellige projekter, herunder desktop-applikationer i Java, responsive webapplikationer og databasedrevne systemer.
              Jeg arbejder rutineret i udviklingsmiljøer som VS Code, IntelliJ, NetBeans og Visual Studio, og bruger GitHub aktivt til versionsstyring
              og samarbejde. På min GitHub kan du se konkrete projekter, der demonstrerer mine færdigheder i objektorienteret programmering,
              databasedesign, API-udvikling og brugergrænseflade-design.
            </p>
            <p>
              Min styrke ligger ikke kun i det tekniske, men også i min erhvervserfaring uden for IT.
              Som tidligere selvstændig og som teamleder i detailbranchen har jeg fået værdifulde erfaringer med <strong>projektstyring, kundekontakt, teamwork og problemløsning</strong>.
              Jeg er vant til at tage ansvar, bevare overblikket under pres og sikre, at opgaver bliver løst til tiden og i høj kvalitet.
              Disse evner kan jeg direkte overføre til softwareudvikling, hvor struktur, samarbejde og præcision er afgørende.
            </p>
            <p>
              Jeg er kendt som mødestabil, lærevillig og resultatorienteret. Jeg motiveres af at udvikle løsninger, der ikke kun fungerer teknisk,
              men også giver værdi for brugerne og virksomheden. Jeg ønsker nu at bruge mine kompetencer og min arbejdserfaring i en professionel
              udviklerrolle, hvor jeg kan bidrage til virksomhedens succes og samtidig fortsætte min egen faglige udvikling.
            </p>
          </div>

          <div>
            <h2>Hvad jeg kan bidrage med</h2>
            <p>
              Jeg tilbyder en kombination af <strong>teknisk viden</strong> og <strong>praktisk erhvervserfaring</strong>.
              Jeg kan indgå i et team, hvor jeg bidrager med softwareudvikling i både frontend og backend, arbejder med databaser og er med i hele
              udviklingsprocessen fra planlægning til implementering og test. Jeg har erfaring med moderne frameworks og værktøjer og
              kan hurtigt tilpasse mig nye teknologier.
            </p>
            <p>
              Jeg brænder især for <strong>Java og databasedrevne systemer</strong>, men jeg har også stor interesse i at udvikle mig inden for webteknologier,
              cloud-løsninger og IT-sikkerhed. Jeg trives i et miljø, hvor jeg kan bidrage aktivt, lære af erfarne kolleger og være en del af et dynamisk udviklingsteam.
            </p>
          </div>

          <div>
            <h2>Hvorfor vælge mig?</h2>
            <ul>
              <li><strong>Stærk teknisk profil:</strong> Erfaring med Java, C#, React, Python, Express, databaser og moderne værktøjer.</li>
              <li><strong>Arbejdsmoral:</strong> Stabil, ansvarsbevidst og hurtig til at lære nyt.</li>
              <li><strong>Tværfaglig erfaring:</strong> Baggrund i ledelse, kundekontakt og projektstyring.</li>
              <li><strong>Team-orienteret:</strong> Vant til at samarbejde, men også selvkørende på egne opgaver.</li>
              <li><strong>Fremtidig udvikler:</strong> Motiveret for at vokse i en professionel IT-karriere og skabe værdi for virksomheden.</li>
            </ul>
          </div>

          <div>
            <h2>Følg mig</h2>
            <div className="social-icons">
              <a href="https://github.com/LSchouG" target="_blank" rel="noopener noreferrer">
                <img src={gitIcon} alt="GitHub" />
              </a>
              <a href="https://www.linkedin.com/in/lars-schou-gregersen-18b477248/" target="_blank" rel="noopener noreferrer">
                <img src={lIIcon} alt="LinkedIn" />
              </a>
              <a href="/uploads/Lars-Gregersen-CV.pdf" download className="cv-icon">
                CV
              </a>
            </div>
          </div>

        </div>
      </div>

      <div className="div-UdvalgtArbejde blue-border">
        <h2 className="h2-blue">Udvalgt Arbejde</h2>
        <div className="work-grid">
          {projects.slice(0, 4).map(p => (
            <WorkCard key={p.id} {...p} />
          ))}
        </div>
      </div>
      <div className="Home-Kontakt">
        {/* Toptekst */}
        <div className="kontaktText">
          <h2>Kontakt mig</h2>
          <p>
            Tak fordi du har taget dig tid til at se min hjemmeside, mit CV og min portefølje.<br />
            Hvis du har spørgsmål, ønsker en samtale eller overvejer at ansætte mig, <br />
            kan du enten sende mig en besked i kontaktformularen eller kontakte mig direkte.
          </p>
        </div>

        {/* Højre kolonne */}
        <div>
          <section>
            <ContactForm title="Kontaktformular" showNote />
          </section>
        </div>

        {/* Venstre kolonne */}
        <div className="kontaktInfo div-center">
          <h3>Kontaktinformation</h3>
          <p><strong>E-mail:</strong> <a href="mailto:larsgregersen1990@gmail.com">larsgregersen1990@gmail.com</a></p>
          <p><strong>Mobil:</strong> <a href="tel:+4560227681">+45 60 22 76 81</a></p>

          <div className="social-icons">
            <a href="https://github.com/LSchouG" target="_blank" rel="noopener noreferrer">
              <img src={gitIcon} alt="GitHub" />
            </a>
            <a href="https://www.linkedin.com/in/lars-schou-gregersen-18b477248/" target="_blank" rel="noopener noreferrer">
              <img src={lIIcon} alt="LinkedIn" />
            </a>
            <a href="/uploads/Lars-Gregersen-CV.pdf" download className="cv-icon">
              CV
            </a>
          </div>
        </div>
      </div>
    </main>
  );
};
